import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-email-printing',
  templateUrl: './email-printing.component.html',
  styleUrls: ['./email-printing.component.scss'],
  standalone: false
})
export class EmailPrintingComponent  implements OnInit {

  @Input() message: string;
  newMessage: any;
  constructor(private domSanitizer: DomSanitizer) { }

  ngOnInit() {
    this.newMessage = this.domSanitizer.bypassSecurityTrustHtml(this.message);
  }

}
